module.exports = __webpack_public_path__ + "static/media/checkmark.f850a26a.svg";